export const TRUST_LEVEL_THRESHOLDS = {
    trusted: 80,
    caution: 50,
};
/** Keys in the `common` translation namespace, without the namespace prefix. */
export const TRUST_LEVEL_LABEL_KEYS = {
    trusted: 'trust.trusted',
    caution: 'trust.caution',
    untrusted: 'trust.untrusted',
};
export function trustLevel(score) {
    if (score >= TRUST_LEVEL_THRESHOLDS.trusted)
        return 'trusted';
    if (score >= TRUST_LEVEL_THRESHOLDS.caution)
        return 'caution';
    return 'untrusted';
}
//# sourceMappingURL=trustLevel.js.map